import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { HomePage, ProductsPage, AboutPage, TermsPage, SonicInsightPage } from './components/site/MarketingPages';
import { LoginPage, SignUpPage } from './components/site/AuthPages';
import { VerificationPending, VerifyPage } from './components/site/VerificationPages';
import { ProjectsPage } from './components/workspace/ProjectsPage';
import { ProjectWorkspace } from './components/workspace/ProjectWorkspace';
import AppWrapper from './AppWrapper';
import ScrollToTop from './components/site/ScrollToTop';
import { AuthProvider, useAuth } from './context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAuth();
  
  if (loading) return null; // Or a loading spinner
  
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Initialize GA4 with Measurement ID from environment variable or placeholder
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-XXXXXXXXXX";
ReactGA.initialize(GA_MEASUREMENT_ID);

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
  }, [location]);

  return null;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsTracker />
        <ScrollToTop />
        <AppWrapper>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/terms" element={<TermsPage />} />
            {/* The old analyzer and history page live on as redirects to the projects page */}
            <Route path="/analyzer" element={<Navigate to="/projects" replace />} />
            <Route path="/history" element={<Navigate to="/projects" replace />} />
            <Route path="/projects" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} />
            <Route path="/projects/:projectId" element={<ProtectedRoute><ProjectWorkspace /></ProtectedRoute>} />
            <Route path="/projects/:projectId/:clipId" element={<ProtectedRoute><ProjectWorkspace /></ProtectedRoute>} />
            <Route path="/sonic-insight" element={<SonicInsightPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/verify-pending" element={<VerificationPending />} />
            <Route path="/verify" element={<VerifyPage />} />
          </Routes>
        </AppWrapper>
      </Router>
    </AuthProvider>
  );
}

export default App;